import { FormProps } from '../types';

const getDefaultLayout = (fields: FormProps['fields']) => Object.keys(fields);

export default getDefaultLayout;
